import styled, { css } from 'styled-components';

export const Row = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin-left: -${theme.spacings.medium};
    margin-right: -${theme.spacings.medium};
  `}
`;
